// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__W0AH8","actionColumn":"ReferralSources_actionColumn__2pw5Z","textButton":"ReferralSources_textButton___48MO"};